import { IConfiguration } from "Common/Interfaces";
import { documentBaseAPI } from "src/Store/DocumentBaseAPI";

const controller = "configurations";
export const configurationsApi = documentBaseAPI.injectEndpoints({
  endpoints: (build) => ({
    getAllowedFileTypes: build.query<IConfiguration, void>({
      query: () => `${controller}/allowedfiletypes`,
    }),
  }),
  overrideExisting: false,
});

export const { useGetAllowedFileTypesQuery } = configurationsApi;
